import React from "react";

const CameraIcon: React.FC = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.668 5.33268H22.4413L20.0013 2.66602H12.0013L9.5613 5.33268H5.33464C4.62739 5.33268 3.94911 5.61363 3.44902 6.11373C2.94892 6.61383 2.66797 7.29211 2.66797 7.99935V23.9993C2.66797 24.7066 2.94892 25.3849 3.44902 25.885C3.94911 26.3851 4.62739 26.666 5.33464 26.666H26.668C27.3752 26.666 28.0535 26.3851 28.5536 25.885C29.0537 25.3849 29.3346 24.7066 29.3346 23.9993V7.99935C29.3346 7.29211 29.0537 6.61383 28.5536 6.11373C28.0535 5.61363 27.3752 5.33268 26.668 5.33268ZM26.668 23.9993H5.33464V7.99935H10.7346L13.1746 5.33268H18.828L21.268 7.99935H26.668V23.9993ZM16.0013 9.33268C14.2332 9.33268 12.5375 10.0351 11.2873 11.2853C10.037 12.5355 9.33464 14.2312 9.33463 15.9993C9.33464 17.7675 10.037 19.4632 11.2873 20.7134C12.5375 21.9636 14.2332 22.666 16.0013 22.666C17.7694 22.666 19.4651 21.9636 20.7153 20.7134C21.9656 19.4632 22.668 17.7675 22.668 15.9993C22.668 14.2312 21.9656 12.5355 20.7153 11.2853C19.4651 10.0351 17.7694 9.33268 16.0013 9.33268ZM16.0013 19.9993C14.9404 19.9993 13.923 19.5779 13.1729 18.8278C12.4227 18.0776 12.0013 17.0602 12.0013 15.9993C12.0013 14.9385 12.4227 13.9211 13.1729 13.1709C13.923 12.4208 14.9404 11.9993 16.0013 11.9993C17.0622 11.9993 18.0796 12.4208 18.8297 13.1709C19.5799 13.9211 20.0013 14.9385 20.0013 15.9993C20.0013 17.0602 19.5799 18.0776 18.8297 18.8278C18.0796 19.5779 17.0622 19.9993 16.0013 19.9993Z"
        fill="#515C66"
      />
    </svg>
  );
};

export default CameraIcon;
